  export const funfact = [
        {
            title: '10+',
            subTitle: 'Highly trained and qualified staff',
        },
        {
            title: '20+',
            subTitle: 'HR & Management Services',
        },
        {
            title: '30+',
            subTitle: 'HR & Management Services',
        },
        {
            title: '40+',
            subTitle: 'Years of industry experience',
        },


    ]